<template>
  <v-card
    outlined
    width="100%"
    @click="onClickRonda(oRonda)"
    :class="oRonda.estado === 'Bloqueado' ? 'grey lighten-2' : 'mx-auto card-rounded over-hidden'"
  >
    <v-row class="pa-3" no-gutters> 
      <v-col cols="10" sm="10" md="10">
        <v-card-title class="item-card-ronda my-0 text-size-2">
          {{ oRonda.nombre }}
        </v-card-title>
        <v-row no-gutters>
         <v-col no-gutters>
           <v-card-subtitle class="item-card-ronda text-size-1">{{$STR.lblPuntosMarcacion}}: {{ oRonda.puntos }}</v-card-subtitle>
           <v-card-subtitle class="item-card-ronda text-size-1">{{$STR.lblHoraProgramada}}: {{ oRonda.hora }}</v-card-subtitle>
           <v-card-subtitle class="item-card-ronda text-size-1" v-if="(oRonda.estado == 'Completada' || oRonda.estado=='Incompleta')">{{$STR.lblHoraEjecutada}}: {{ onGetHoraEjecutada(oRonda) }}</v-card-subtitle>
           <v-card-subtitle class="item-card-ronda text-size-1">
             Estado: <v-chip label :color="onGetColorEstado(oRonda)" class="white--text" >{{ oRonda.estado }}</v-chip>
           </v-card-subtitle>
         </v-col>
       </v-row>
      </v-col>

      <v-col cols="2" sm="2" md="1" class="d-flex justify-center align-center text-xs-center">
        <v-btn large icon @click="onClickRonda(oRonda)">
          <v-icon color="#003743">mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>

    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'RondaItemCard',
  props: {
    oRonda: {
      type: Object,
      default:()=> {}
    }
  },
  data() {
    return {
    };
  },
  computed: {

  },
  mounted() {
    
  },
  methods: {
    onGetColorEstado(oRonda){
      switch (oRonda.estado) {
        case 'Sin iniciar':
          return 'red accent-2'
        case 'En progreso':
          return 'primary'
        case 'Completada':
          return '#019578'
        case 'Incompleta':
          return '#F9A825'
        default:
          return 'grey darken-1'
      }
    },
    onGetLabelHoraByEstado(sEstado){
      switch (sEstado) {
        case 'Completada':
        case 'Incompleta':
          return this.$STR.lblHoraEjecutada
        default:
          return this.$STR.lblHoraProgramada
      }
    },

    onGetHoraEjecutada(oRonda){
      switch (oRonda.estado) {
        case 'Completada':
        case 'Incompleta':
          const fechaISO = oRonda.sFechaEjecucion.replace(" ", "T"); // "2025-05-29T11:44:48"
          const fecha = new Date(fechaISO);
          // Validar que la fecha es válida
          if (!isNaN(fecha.getTime())) {
            const sHora = fecha.toTimeString().split(" ")[0]; // "11:44:48"
            return sHora
          }
          return oRonda.sFechaEjecucion 
        default:
          return oRonda.hora 
      }
    
    },

    onClickRonda(oRonda){
      this.$emit('onClickRonda', oRonda)
    }
  },
};
</script>

<style scoped>

.v-list-item-content {
  font-size: 14px;
}
.item-card-ronda{
  padding: 3px 5px 3px 5px;
}

</style>
